import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_Label.scss';

/**
 * A label element component which wraps a HTML label and adds to it the basic bootstrap css rules.
 * All arbitrary DOM properties and attributes (including event handlers) are accepted and passed to HTML label element.
 */
const Label = props => {
  const { className, children, innerRef, ...rest } = props;
  const classes = classNames('B360Label', className);
  return (
    <label className={classes} ref={innerRef} {...rest}>
      {children}
    </label>
  );
};

Label.propTypes = {
  /**
   * A custom className for the component
   */
  className: PropTypes.string,
  /**
   * The component's children
   */
  children: PropTypes.node,
  /**
   * a ref handled by the native html element
   */
  innerRef: PropTypes.func
};

export default Label;
